import FetcherRepository from './FetcherRepository.js'

const AUTHENTICATION_TOKEN_KEY_PREFIX = 'authenticationToken'

/**
 * @class ConfigFetcherRepository
 * @implements FetcherRepository
 */
export default class ConfigFetcherRepository extends FetcherRepository {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   */
  constructor({config, errorFactory}) {
    super()
    this._config = config
    this._errorFactory = errorFactory
  }

  getAuthenticationToken({userId}) {
    const cookie = this._config.get('cookie')
    const token = cookie[`${AUTHENTICATION_TOKEN_KEY_PREFIX}_${userId}`]

    const hasToken = typeof token === 'string' && Boolean(token.length)
    return hasToken ? Promise.resolve(token) : Promise.reject(this._errorFactory('Token does not exist in config'))
  }
}
